import { RegistryItem, ModuleLoaderDef } from '@awp/dynamic-outlet'

export const MODULE_REGISTER: ModuleLoaderDef[] = [
  {
    name: 'CommonUiModule',
    load: () => import('@awp/common').then(m => m.CommonUiModule)
  }
];

export const COMPONENT_REGISTER: RegistryItem[] = [
  {
    componentName: 'Nav Menu Widget',
    componentType: 'NavMenuWidgetComponent',
    module: 'CommonUiModule'
  }
];